import React, { useEffect } from 'react';
import DropdownMenu from '../components/Menu';
import { papanicolau, consul_ultra, paquete, consul_colpos_ultra, consul_papa_ultra, colposcopia, implante, diuM, diu, cesarea, laparotomia, ameu, parto, histerectomia, biopsia, condilomas, Daniel } from '../resources';
import './Servicios.css';
import AOS from 'aos';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import '../styles.css';
import "./Home.css"
import CofeprisAdGallery from '../components/CofeprisAd';
const serviciosGenerales = [
  {
    title: 'Consulta primera vez + ultrasonido pélvico/vaginal',
    price: '$900.00 MXN',
    recomendation: '',
    image: consul_ultra,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el ultrasonido pélvico."
  },
  {
    title: 'Consulta de control prenatal de 1ra vez + ultrasonido de embarazo',
    price: '$900.00 MXN',
    recomendation: '',
    image: paquete,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el paquete de consulta de primera vez y ultrasonido de embarazo."
  },
  {
    title: 'Consulta subsecuente',
    price: '$800.00 MXN',
    recomendation: '',
    image: paquete,
    messageBase: "Hola doctor Daniel, quisiera más información para una consulta subsecuente."
  },
  {
    title: 'Consulta + ultrasonido pélvico + Colposcopia + Papanicolaou',
    price: '$1700.00 MXN',
    recomendation: '',
    image: paquete,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el paquete de ultrasonido pélvico, colposcopia y Papanicolaou."
  },
  {
    title: 'Consulta + Colposcopia + Ultrasonido',
    price: '$1500.00 MXN',
    recomendation: '',
    image: consul_colpos_ultra,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el paquete de consulta, colposcopia y ultrasonido."
  },
  {
    title: 'Consulta + Papanicolaou + Ultrasonido',
    price: '$1500.00 MXN',
    recomendation: '',
    image: consul_papa_ultra,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el paquete de consulta, Papanicolaou y ultrasonido."
  },
];

const serviciosEspecializados = [
  {
    title: 'Colposcopia',
    price: '$1000.00 MXN',
    recomendation: '',
    image: colposcopia,
    messageBase: "Hola doctor Daniel, quisiera más información sobre la colposcopia."
  },
  {
    title: 'Papanicolaou',
    price: '$700.00 MXN',
    recomendation: '',
    image: papanicolau,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el Papanicolaou."
  },
  {
    title: 'Implante subdérmico',
    price: '$3000.00 MXN',
    recomendation: '',
    image: implante,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el implante subdérmico."
  },
  {
    title: 'DIU Mirena',
    price: '$4500.00 MXN',
    recomendation: '',
    image: diuM,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el DIU Mirena."
  },
  {
    title: 'DIU “T” de cobre',
    price: '$1000.00 MXN',
    recomendation: '',
    image: diu,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el DIU T de cobre."
  },
  {
    title: 'Cesárea',
    price: `Paquete Operes: $28,000.00 MXN\nPaquete Pro: $30,000.00 MXN\nPaquete Premium: $38,000.00 MXN`,
    recomendation: '',
    image: cesarea,
    messageBase: "Hola doctor Daniel, quisiera más información sobre la cesárea."
  },
  {
    title: 'Laparotomía',
    price: '$24,000.00 MXN',
    recomendation: '',
    image: laparotomia,
    messageBase: "Hola doctor Daniel, quisiera más información sobre la laparotomía."
  },
  {
    title: 'Parto',
    price: `Paquete Esencial: $25,000.00 MXN\nPaquete Premium: $32,000.00 MXN`,
    recomendation: '',
    image: parto,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el parto."
  },
  {
    title: 'Histerectomía',
    price: '$28,500.00 MXN',
    recomendation: '',
    image: histerectomia,
    messageBase: "Hola doctor Daniel, quisiera más información sobre la histerectomía."
  },
  {
    title: 'AMEU / Legrado',
    price: '$11,000.00 MXN',
    recomendation: '',
    image: ameu,
    messageBase: "Hola doctor Daniel, quisiera más información sobre el AMEU."
  },
  {
    title: 'Toma de biopsia endometrial',
    price: '$10,000.00 MXN',
    recomendation: '',
    image: biopsia,
    messageBase: "Hola doctor Daniel, quisiera más información sobre la toma de biopsia endometrial."
  },
  {
    title: 'Cauterización de condilomas',
    price: '$1,500.00 - $2,000.00 MXN',
    recomendation: '',
    image: condilomas,
    messageBase: "Hola doctor Daniel, quisiera más información sobre la cauterización de condilomas."
  },
];

const Servicios = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <>
    <div className="floating-buttons-container">
               <div className="floating-megafono"> <CofeprisAdGallery /></div>
              <div className="watermark-floating"></div>
              <FloatingWhatsApp
              className="floating-whatsapp"
                phoneNumber="5219511035059"
                avatar={Daniel}
                accountName="Dr. Daniel Sánchez Sarabia"
                chatMessage="¡Hola! ¿En qué puedo ayudarte?"
                placeholder="Escribe tu mensaje..."
                darkMode={false}
              />
          </div>
      <div className="carousel-container">
        <div className="carousel-track">
          <img src={papanicolau} alt="Papanicolaou" className="carousel-image" />
          <img src={consul_ultra} alt="Consulta + Ultrasonido" className="carousel-image" />
          <img src={paquete} alt="Paquete de servicios" className="carousel-image" />
          <img src={consul_colpos_ultra} alt="Colposcopia + Ultrasonido" className="carousel-image" />
          <img src={consul_papa_ultra} alt="Papanicolaou + Ultrasonido" className="carousel-image" />
          <img src={colposcopia} alt="Colposcopia" className="carousel-image" />
          <img src={implante} alt="Implante" className="carousel-image" />
          <img src={diuM} alt="DIU Mirena" className="carousel-image" />
          <img src={diu} alt="DIU de Cobre" className="carousel-image" />
          <img src={cesarea} alt="Cesárea" className="carousel-image" />
          <img src={laparotomia} alt="Laparotomía" className="carousel-image" />
          <img src={ameu} alt="AMEU" className="carousel-image" />
          <img src={parto} alt="Parto" className="carousel-image" />
          <img src={histerectomia} alt="Histerectomía" className="carousel-image" />
          <img src={biopsia} alt="Biopsia" className="carousel-image" />
          <img src={condilomas} alt="Tratamiento de condilomas" className="carousel-image" />
        </div>
      </div>

      

      <div className="servicios-container">
        <h2 className="servicio-titulo-seccion">Servicios Generales</h2>
        {serviciosGenerales.map((servicio, index) => (
          <div key={index} data-aos="fade-up">
            <DropdownMenu {...servicio} />
          </div>
        ))}

        <h2 className="servicio-titulo-seccion">Servicios Especializados</h2>
        {serviciosEspecializados.map((servicio, index) => (
          <div key={index} data-aos="fade-up" data-aos-delay={index * 100}>
            <DropdownMenu {...servicio} />
          </div>
        ))}

        <div className="recomendaciones-section" data-aos="fade-up">
          <h2 className="servicio-titulo-seccion">Recomendaciones</h2>
          <h3 className="recomendacion-subtitulo">
            Para obtener resultados precisos en sus estudios ginecológicos, considere las siguientes indicaciones previas a su consulta o procedimiento. Cumplir con estas recomendaciones es fundamental para garantizar la calidad del diagnóstico y su bienestar.
          </h3>

          <div className="recomendacion-bloque">
            <h3 className="recomendacion-subtitulo">Colposcopia y Papanicolaou</h3>
            <ul>
              <li>No acudir durante el periodo menstrual o esperar al menos 5 días después del último sangrado.</li>
              <li>No tener relaciones sexuales 48 horas antes de los estudios.</li>
              <li>No usar duchas vaginales.</li>
              <li>No utilizar medicamentos por vía vaginal.</li>
            </ul>
          </div>

          <div className="recomendacion-bloque">
            <h3 className="recomendacion-subtitulo">Ultrasonido pélvico</h3>
            <ul>
              <li>Tome un litro de agua 20 minutos antes de su consulta.</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Servicios;
